import { firebase } from "@firebase/app";
import "@firebase/firestore";
import store from "../store";
require('firebase/auth')
require('firebase/storage')

//UPDATE WITH YOUR CONFIG

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAFdpTzZtA48Fo-vjenxPI5QOoBqbSQ36c",
  authDomain: "digital-menu-fec32.firebaseapp.com",
  databaseURL: "https://digital-menu-fec32.firebaseio.com",
  projectId: "digital-menu-fec32",
  storageBucket: "digital-menu-fec32.appspot.com",
  messagingSenderId: "971829573213",
});

export const db = firebaseApp.firestore();

var storage = firebaseApp.storage();
var storageRef = storage.ref();
export const imagesRef = storageRef.child('restaurants');

firebase.auth().signInAnonymously()
.then(function () {
  store.dispatch("commitLocalData");
})
.catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  console.log(errorCode);
  console.log(errorMessage);
  // ...
});

firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    // User is signed in.
    // var isAnonymous = user.isAnonymous;
    // var uid = user.uid;
    // console.log(isAnonymous);
    // console.log(uid);
    // ...
  } else {
    // User is signed out.
    // ...
  }
  // ...
});
